var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCollateralization(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.51042 0.653125C10.0542 2.19688 12.0927 3.12708 14.2698 3.30521C14.7052 3.34479 15.0417 3.70104 15.0417 4.13646V6.53125C15.0417 11.5583 12.3104 16.2292 7.93646 18.7031C7.79792 18.7625 7.65938 18.8021 7.52083 18.8021C7.38229 18.8021 7.22396 18.7823 7.10521 18.7031C2.73125 16.2292 0 11.5583 0 6.53125V4.13646C0 3.70104 0.336458 3.34479 0.771875 3.30521C2.94896 3.12708 4.9875 2.19688 6.53125 0.653125L6.92708 0.2375C7.08542 0.0791667 7.30313 0 7.52083 0C7.73854 0 7.95625 0.0791667 8.11458 0.2375L8.51042 0.653125ZM7.44167 11.8156L11.1427 7.79792C11.4396 7.46146 11.4198 6.92708 11.0833 6.61042C10.7469 6.31354 10.2323 6.33333 9.91562 6.66979L6.80833 10.0542L5.32396 8.56979C5.00729 8.25313 4.47292 8.25313 4.15625 8.56979C3.83958 8.88646 3.83958 9.42083 4.15625 9.7375L6.23438 11.8552C6.39271 12.0135 6.61042 12.0927 6.82812 12.0927H6.84792C7.06562 12.0729 7.28333 11.974 7.44167 11.8156Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCollateralization);
export default __webpack_public_path__ + "static/media/icon-collateralization.bb1a2513.svg";
export { ForwardRef as ReactComponent };